// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1ZECv","consentsList":"PatientConsents_consentsList__2UxCq","consentsListEmpty":"PatientConsents_consentsListEmpty__1fo1E"};